export default {
  init() {
    const body = $('body');

    // Custom Dropdown for Mobile booking
    const rsdDropdown = $('.rsd-dropdown');
    if (rsdDropdown.length) {
      rsdDropdown.each(function() {
        let thisDropdown = $(this);
        let dropdownId = thisDropdown.data('rsd-dropdown');
        let disableForm = false;
        let hotelBookingContainer = thisDropdown.closest('.hotel-booking-form-container, .hotel-booking-fixed-lg, .hotel-booking-widget-container');

        if (thisDropdown.data('rsd-disable-form')) {
          disableForm = thisDropdown.data('rsd-disable-form');
        }

        thisDropdown.on('click', function() {
          $('#' + dropdownId).toggle();

          if (disableForm) {
            hotelBookingContainer.toggleClass('disable');
            if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
              body.toggleClass('bookwidget-guests');
            }
          }
        });

        if (hotelBookingContainer.length) {
          hotelBookingContainer.find('.apply-btn').on('click', function() {
            $('#' + dropdownId).hide();
            hotelBookingContainer.removeClass('disable');

            if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
              body.removeClass('bookwidget-guests');
            }
          });

          // hide when clicked outside dropdown
          $(document).on('click', function(event) {
            if (
              !hotelBookingContainer.is(event.target) && hotelBookingContainer.has(event.target).length === 0
            ) {
              $('#' + dropdownId).hide();
              hotelBookingContainer.removeClass('disable');

              if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
                body.removeClass('bookwidget-guests');
              }
            }
          });
        }
      });
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/bookingWidget.js